/*
  image-retry.js
  ----------------------------------------------------------------------------
  Defensive fix for intermittent broken product images in flaky in-app
  browsers — notably Instagram's in-app webview (links opened from Stories).
  Those browsers sometimes abort lazy-loaded or oversized image fetches,
  leaving the broken-image "?" icon on collection grid cards.

  When a product-card <img> fires an `error`, we retry it once or twice with a
  smaller Shopify CDN width and an eager load. Whatever the underlying cause
  (aborted lazy fetch, too-heavy fallback src, transient webview blip), a
  one-shot retry recovers it. Loaded globally from layout/theme.liquid.

  Added 2026-06-12. See Prestige-2026/CLAUDE.md "Collection grid broken images".
  ----------------------------------------------------------------------------
*/
(function () {
  var MAX_RETRIES = 2;
  var RETRY_WIDTH = 800; // cap retry fetch size so flaky connections can finish

  // Rewrite a Shopify CDN image URL to a smaller width so the retry is lighter.
  function shrink(url, width) {
    try {
      var u = new URL(url, window.location.href);
      if (!/cdn\.shopify\.com/.test(u.hostname) && u.pathname.indexOf('/cdn/') === -1) {
        return url; // not a Shopify-served image — leave it alone
      }
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function handleError(event) {
    var img = event.target;
    if (!img || img.tagName !== 'IMG') return;
    // Limit to product grid images; don't touch every image on the page.
    if (!img.closest || !img.closest('.product-card')) return;

    var tries = parseInt(img.getAttribute('data-retry') || '0', 10);
    if (tries >= MAX_RETRIES) return;
    tries++;
    img.setAttribute('data-retry', String(tries));

    // Force eager load and drop srcset so the retry uses a single small src
    // (flaky webviews often mishandle srcset/sizes selection).
    img.loading = 'eager';
    if (img.srcset) {
      img.dataset.origSrcset = img.srcset;
      img.removeAttribute('srcset');
    }

    var base = img.currentSrc || img.src;
    var next = shrink(base, RETRY_WIDTH);
    // cache-bust so the browser re-requests instead of reusing the failed entry
    next += (next.indexOf('?') === -1 ? '?' : '&') + 'r=' + tries;

    // small backoff between attempts
    setTimeout(function () { img.src = next; }, 300 * tries);
  }

  // `error` events don't bubble — listen in the capture phase on the document.
  document.addEventListener('error', handleError, true);
})();
